import ReactMarkdown from "react-markdown";

const MD_COMPONENTS = {
  p: (props) => <p className="mb-2 last:mb-0" {...props} />,
  strong: (props) => <strong className="text-[var(--text)] font-semibold" {...props} />,
  em: (props) => <em className="text-[var(--text-muted)] not-italic" {...props} />,
  ul: (props) => <ul className="list-disc pl-4 space-y-0.5 mb-2 marker:text-[var(--copper)]" {...props} />,
  ol: (props) => <ol className="list-decimal pl-4 space-y-0.5 mb-2 marker:text-[var(--copper)]" {...props} />,
  li: (props) => <li className="text-[var(--text-muted)]" {...props} />,
  h1: (props) => <h3 className="text-[var(--text)] font-display text-[14px] mt-3 mb-1" {...props} />,
  h2: (props) => <h3 className="text-[var(--text)] font-display text-[14px] mt-3 mb-1" {...props} />,
  h3: (props) => <h3 className="text-[var(--text)] font-display text-[13px] mt-2 mb-1" {...props} />,
  code: ({ inline, ...props }) => inline
    ? <code className="bg-black/[0.06] px-1 rounded text-[12px] font-mono text-[var(--copper)]" {...props} />
    : <code className="block bg-black/[0.04] p-2 rounded-sm text-[12px] font-mono overflow-x-auto" {...props} />,
  a: (props) => <a className="text-[var(--copper)] hover:underline" {...props} />,
  blockquote: (props) => <blockquote className="border-l-2 border-[var(--copper)]/40 pl-3 text-[var(--text-muted)] italic my-2" {...props} />,
};

export function AIMarkdown({ children, className = "" }) {
  return (
    <div className={`ai-md text-[13px] leading-relaxed ${className}`}>
      <ReactMarkdown components={MD_COMPONENTS}>{children || ""}</ReactMarkdown>
    </div>
  );
}
